const shared = {
    alignItems: 'center' as const,
    borderColor: '$avatarBorder',
    borderRadius: '$avatarBorder',
    borderStyle: 'solid' as const,
    borderWidth: '$avatar',
    display: 'flex' as const,
    height: '$avatar',
    justifyContent: 'center' as const,
    minWidth: '$avatar',
    width: '$avatar',
}

export const styledTicketAvatar = {
    ...shared,
    boxSizing: 'border-box',
    color: '$avatarText',
    display: 'flex',
    variants: {
        size: {
            big: {
                borderRadius: '$avatarBigBorder',
                fontSize: '$avatarBigText',
                height: '$avatarBig',
                minWidth: '$avatarBig',
                width: '$avatarBig',
            },
            mid: {
                borderRadius: '$avatarMidBorder',
                fontSize: '$avatarMidText',
                height: '$avatarMid',
                minWidth: '$avatarMid',
                width: '$avatarMid',
            },
            small: {
                borderRadius: '$avatarSmallBorder',
                fontSize: '$avatarSmallText',
                height: '$avatarSmall',
                minWidth: '$avatarSmall',
                width: '$avatarSmall',
            },
        },
    },
}
